import { render, staticRenderFns } from "./AdjuntarArchivo.vue?vue&type=template&id=35ba034c&"
import script from "./AdjuntarArchivo.vue?vue&type=script&lang=js&"
export * from "./AdjuntarArchivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports